import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'dashboard_amc.my_last_reimbursement.title',
  },
  lossDate: {
    id: 'dashboard_amc.claim.loss_date',
  },
  amount: {
    id: 'dashboard_amc.claim.amount',
  },
  seeDetails: {
    id: 'dashboard_auto.last_sinister.see_details',
  },
  actif: {
    id: 'dashboard_auto.mes_contracts.actif',
  },
  enCours: {
    id: 'dashboard_auto.mes_contracts.encours',
  },
  emptyState: {
    id: 'dashboard_amc.last_sinister.empty_state_title',
  },
  claimNumber: {
    id: 'dashboard_amc.contract.claim_number',
  },
});
